import * as types from '../types'
import * as geoApi from '../../api/core/geo.dd'
import { store } from '../store';

const state = {
  selectedGeoZone:{},
  geoZones: [],
  geoZonesMeta:{},
  geoZoneTypes:[],
  geoZoneCustomFields:[],
  unitTypeDataFieldStatuses:[],
  unitTypeGeoZoneEvents:[],
  unitTypeGeoZoneEventsMeta: {pagination:{}},
  assetGroupGeoZoneEventsOnGeoZone:[],
  assetGroupGeoZoneEventsOnGeoZoneMeta: {pagination:{}},
  assetsWithinGeoZone:[],
  assetsWithinGeoZoneMeta:{pagination:{}},
  eventsWithinGeoZone:[],
  eventsWithinGeoZoneMeta:{pagination:{}},
  geoZoneProcessedEvents:[],
  geoZoneProcessedEVentsMeta:{pagination:{}},
  geoZoneInGeoZoneSince:[]
}

const getters = {
    [types.GEO_ZONE]: (state) => {
      return state.selectedGeoZone
    },  
    [types.GEO_ZONES]: (state) => {
        return state.geoZones
    },
    [types.GEO_ZONES_META]: (state) => {
      return state.geoZonesMeta
    },    
    [types.GEO_ZONE_TYPES]: (state) => {
      return state.geoZoneTypes
    },
    [types.GEO_ZONE_CUSTOM_FIELDS]: (state) => {
      return state.geoZoneCustomFields
    },    
    [types.GEO_ZONE_PROCESSED_EVENTS]: (state) => {
      return state.geoZoneProcessedEvents
    },      
    [types.ASSETS_WITHIN_GEO_ZONE]: (state) => {
      return state.assetsWithinGeoZone
    },    
    [types.EVENTS_WITHIN_GEO_ZONE]: (state) => {
      return state.eventsWithinGeoZone
    },      
    [types.UNIT_TYPE_GEO_ZONE_EVENTS]: (state) => {
      return state.unitTypeGeoZoneEvents
    },
    [types.UNIT_TYPE_GEO_ZONE_EVENTS_PAGINATION]: (state) => {
      return state.unitTypeGeoZoneEventsMeta
    },      
    [types.ASSET_GROUP_GEO_ZONE_EVENTS_ON_GEO_ZONE]: (state) => {
      return state.assetGroupGeoZoneEventsOnGeoZone
    },     
    [types.ASSET_GROUP_GEO_ZONE_EVENTS_ON_GEO_ZONE_META]: (state) => {
      return state.assetGroupGeoZoneEventsOnGeoZoneMeta
    },
    [types.ASSETS_IN_GEO_ZONE_SINCE]: (state) => {
      return state.geoZoneInGeoZoneSince
    }    
}

const mutations = {
    [types.GEO_ZONE]: (state, payload) => {
      state.selectedGeoZone = payload.data
    },  
    [types.GEO_ZONES]: (state, payload) => {
      state.geoZones     = payload.data
      state.geoZonesMeta = payload.meta 
    },
    [types.GEO_ZONE_CUSTOM_FIELDS]: (state, payload) => {
      state.geoZoneCustomFields = payload.data   
    },    
    [types.ASSETS_WITHIN_GEO_ZONE]: (state, payload) => {            
      state.assetsWithinGeoZone     = payload.data
      state.assetsWithinGeoZoneMeta = payload.meta        
    },      
    [types.EVENTS_WITHIN_GEO_ZONE]: (state, payload) => {            
      state.eventsWithinGeoZone     = payload.data
      state.eventsWithinGeoZoneMeta = payload.meta        
    },        
    [types.ASSET_GROUP_GEO_ZONE_EVENTS_ON_GEO_ZONE]: (state, payload) => {      
      state.assetGroupGeoZoneEventsOnGeoZone     = payload.data
      state.assetGroupGeoZoneEventsOnGeoZoneMeta = payload.meta 
    },    
    [types.GEO_ZONE_TYPES]: (state, payload) => {
      state.geoZoneTypes = payload
    },
    [types.UNIT_TYPE_GEO_ZONE_EVENTS]: (state, payload) => {
      state.unitTypeGeoZoneEvents = payload.data
      state.unitTypeGeoZoneEventsMeta = payload.meta
    },
    [types.GEO_ZONE_PROCESSED_EVENTS]: (state, payload) => {
      state.geoZoneProcessedEvents     = payload.data
      state.geoZoneProcessedEventsMeta = payload.meta
    },
    [types.ASSETS_IN_GEO_ZONE_SINCE]: (state, payload) => {
      state.geoZoneInGeoZoneSince     = payload.data
    }            
}

const actions = {  
  [types.UNIT_TYPE_GEO_ZONE_EVENTS]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        geoApi.unitTypeGeoZoneEvents(payload.data, payload.params).then( (res) => {
            commit(types.UNIT_TYPE_GEO_ZONE_EVENTS, res)
            resolve(res)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  },   
  [types.GEO_ZONE_CUSTOM_FIELDS]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        geoApi.allGeoZoneCustomFields(payload.data, payload.params).then( (res) => {
            commit(types.GEO_ZONE_CUSTOM_FIELDS, res)
            resolve(res)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  },       
  [types.SAVE_CUSTOM_FIELDS_ON_GEO_ZONE]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        geoApi.saveCustomFieldsOnGeoZone(payload.data, payload.params).then( (res) => {
            resolve(res)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  }, 

  [types.SAVE_GEO_ZONE_CUSTOM_FIELD_VALUES]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        geoApi.saveGeoZoneCustomFieldValues(payload.data, payload.params).then( (res) => {
            resolve(res)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  },   

  [types.ASSET_GROUP_GEO_ZONE_EVENTS_ON_GEO_ZONE]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        geoApi.getAssetGroupGeoZoneEventsOnGeoZone(payload.data, payload.params).then( (res) => {            
            commit(types.ASSET_GROUP_GEO_ZONE_EVENTS_ON_GEO_ZONE,res)
            resolve(res)            
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  },    
  [types.GEO_ZONE_EVENTS_ON_UNIT_TYPE_AND_GEO_ZONE]: ({ commit }, payload) => {
    let p = new Promise((resolve) => {
        geoApi.geoZoneEventsOnUnitTypeAndGeoZone(payload.data, payload.params).then( (res) => {
            resolve(res.data)
        }).catch((e) => {
          resolve(null)
        })        
    })
    return p
  },     
  [types.UNIT_TYPE_GEO_ZONE_EVENTS_SEARCH]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        geoApi.unitTypeGeoZoneEventsSearch(payload.data, payload.params).then( (res) => {
            commit(types.UNIT_TYPE_GEO_ZONE_EVENTS, res)
            resolve(res)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  },   
  [types.SAVE_GEO_ZONE]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        geoApi.saveGeoZone(payload.data, {}).then( (res) => {
            resolve(res.data)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  }, 
  [types.SAVE_GEO_ZONE_EVENT]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        geoApi.saveGeoZoneEvent(payload.data, {}).then( (res) => {          
            resolve(res.data)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  }, 
  [types.DELETE_GEO_ZONE]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        geoApi.deleteGeoZone(payload.data, {}).then( (res) => {
            resolve(res)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  }, 
  [types.GEO_ZONE]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        geoApi.getGeoZone(payload.data, payload.params).then( (res) => {
            commit(types.GEO_ZONE, res)
            resolve(res)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  },   
  [types.GEO_ZONES]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        geoApi.allGeoZones(payload.data, payload.params).then( (res) => {
            commit(types.GEO_ZONES, res)
            resolve(res)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  }, 
  [types.CLEAR_GEO_ZONES]: ({commit}) => {    
      commit(types.GEO_ZONES, [])
  },   
  [types.GEO_ZONE_TYPES]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        geoApi.allGeoZoneTypes(payload.data, payload.params).then( (res) => {
            commit(types.GEO_ZONE_TYPES, res.data)
            resolve(res)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  },
  [types.SAVE_GEO_ZONE_TYPE]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        geoApi.saveGeoZoneType(payload.data, payload.params).then( (res) => {
            resolve(res)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  },
  [types.SEARCH_GEO_ZONES]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
          geoApi.searchGeoZones(payload.data, payload.params).then( (res) => {
            commit(types.GEO_ZONES, res.data)
            resolve()
        }).catch((e) => {
          reject(e.data)
        })       
    })
    return p
  },
  [types.ASSETS_WITHIN_GEO_ZONE]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        geoApi.getAssetsWithinGeoZone(payload.data, payload.params).then( (res) => {          
            commit(types.ASSETS_WITHIN_GEO_ZONE, res)
            resolve(res)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  },   
  [types.EVENTS_WITHIN_GEO_ZONE]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        geoApi.getEventsWithinGeoZone(payload.data, payload.params).then( (res) => {          
            commit(types.EVENTS_WITHIN_GEO_ZONE, res)
            resolve(res)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  },     
  [types.GEO_ZONE_PROCESSED_EVENTS]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        geoApi.getGeoZoneProcessedEvents(payload.data, payload.params).then( (res) => {          
            commit(types.GEO_ZONE_PROCESSED_EVENTS, res)
            resolve(res)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  },      
  [types.ASSETS_IN_GEO_ZONE_SINCE]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        geoApi.assetsInGeoZoneSince(payload.data, payload.params).then( (res) => {          
            commit(types.ASSETS_IN_GEO_ZONE_SINCE, res)
            resolve(res)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  },     
  [types.GEO_CODE_ADDRESS]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        geoApi.geoCodeAddress(payload.data).then( (res) => {          
            resolve(res)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  },         
}
 
export default {
  state,
  getters,
  mutations,
  actions
}
